"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var UAParser = require('ua-parser-js');
var uuidv4 = require('uuid/v4');
var UNKNOWN_VALUE = 'Unknown';
var USER_BROWSER_ID_KEY = 'UserBrowserId';
var SESSION_QUERY_PARAMETERS_KEY = 'session-query-parameters';
var UserBrowser = (function () {
    function UserBrowser() {
        this.initQueryParameters();
        var ua = new UAParser().getResult();
        this.Os = ua.os.name || UNKNOWN_VALUE;
        this.OsVersion = ua.os.version || UNKNOWN_VALUE;
        this.Vendor = ua.device.vendor || UNKNOWN_VALUE;
        this.Model = ua.device.model || UNKNOWN_VALUE;
        this.BrowserType = ua.browser.name || UNKNOWN_VALUE;
        this.BrowserVersion = ua.browser.major || UNKNOWN_VALUE;
        this.FormFactor =
            (ua.device.type === 'tablet' && 'Tablet') ||
                (ua.device.type === 'mobile' && 'Mobile') ||
                'Desktop';
        this.UserAgent = navigator.userAgent;
        this.CookiesEnabled = navigator.cookieEnabled;
        this.UserBrowserId = this.retrieveId();
    }
    UserBrowser.prototype.retrieveId = function () {
        var id = undefined;
        id = js_cookie_1.default.get(USER_BROWSER_ID_KEY);
        if (!id) {
            id = localStorage.getItem(USER_BROWSER_ID_KEY);
        }
        if (!id) {
            id = uuidv4();
        }
        try {
            localStorage.setItem(USER_BROWSER_ID_KEY, id);
        }
        catch (_a) { }
        return id;
    };
    UserBrowser.prototype.initQueryParameters = function () {
        var sessionQueryParameters = sessionStorage.getItem(SESSION_QUERY_PARAMETERS_KEY);
        if (!sessionQueryParameters) {
            sessionQueryParameters = window.location.search;
            try {
                sessionStorage.setItem(SESSION_QUERY_PARAMETERS_KEY, sessionQueryParameters);
            }
            catch (_a) { }
        }
        if (window.URLSearchParams) {
            this.sessionQueryParameters = new window.URLSearchParams(sessionQueryParameters);
        }
    };
    UserBrowser.get = function () {
        if (!UserBrowser.instance) {
            UserBrowser.instance = new UserBrowser();
        }
        return UserBrowser.instance;
    };
    UserBrowser.clearInstance = function () {
        UserBrowser.instance = undefined;
    };
    UserBrowser.prototype.isIE = function () {
        return this.BrowserType ? this.BrowserType.toLowerCase() === 'ie' : false;
    };
    return UserBrowser;
}());
exports.default = UserBrowser;
//# sourceMappingURL=UserBrowser.js.map